import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import UseStateContext from './session/UseStateContext'
import Navbar from './components/Navbar';
import Banner from './components/Banner';
import successImg from "../images/check-circle-1.svg";
import Success from './components/Success';
import Header from './components/Header';

const InformationMaterial = () => {

    const { context, setContext } = UseStateContext();

    const [lead, setLead] = useState({});
    const [wantedServices, setWantedServices] = useState([]);
    const [wantedInformationMaterial, setWantedInformationMaterial] = useState([]);
    const [moreWantedInformationMaterial, setMoreWantedInformationMaterial] = useState("");
    const [interests, setInterests] = useState([]);
    const [moreInformation, setMoreInformation] = useState("");

    const productAreas = ["Modern Workplace", "Cloud Services", "Netzwerkinfrastruktur", "Pro AV", "Security (digital/physisch)", "eMobility", "Büro- / Geschäftsbedarf"];

    let navigate = useNavigate();

    useEffect(() => {
        if (context.lead) {
            loadLead(context.lead);
        }
    }, [context.lead]);

    const loadLead = async (lead) => {
        setLead(lead);
    }

    const onSubmit = () => {

        let wantedServicesList = wantedServices.join(";");
        let wantedInformationMaterialList = wantedInformationMaterial.join(";");
        let interestList = interests.join(";");

        wantedInformationMaterialList = wantedInformationMaterialList += `;${moreWantedInformationMaterial}`;

        let body = {
            ...lead,
            wantedServices: wantedServicesList,
            wantedInformationMaterial: wantedInformationMaterialList,
            interests: interestList,
            moreInformation: moreInformation,
        };

        axios.post(`/Lead`, body).then(() => {
            setContext({ lead: lead });
            navigate("/success");
        });
    }

    const updateWantedServices = (e, value) => {

        let addElement = e.target.checked;
        let array = [...wantedServices];

        if (addElement) {
            array.push(value);
        } else {
            let index = array.findIndex(a => a == value);
            array.splice(index);
        }

        setWantedServices(array)
    }

    const updateWantedInformationMaterial = (e, value) => {

        let addElement = e.target.checked;
        let array = [...wantedInformationMaterial];

        if (addElement) {
            array.push(value);
        } else {
            let index = array.findIndex(a => a == value);
            array.splice(index);
        }

        setWantedInformationMaterial(array)
    }

    const updateInterests = (e, value) => {
        let addElement = e.target.checked;
        let array = [...interests];

        if (addElement) {
            array.push(value);
        } else {
            let index = array.findIndex(a => a === value);
            if (index !== -1) {
                array.splice(index, 1); // Remove 1 element at the found index
            }
        }

        setInterests(array);
    }

    let validation = wantedServices.length > 0 && (wantedInformationMaterial.length > 0 || moreWantedInformationMaterial.length > 0) && interests.length > 0;

    return (
        <>
            <Navbar />
            <Banner />
            <div className='container mt-4 page-container'>
                <Header />

                <Success lead={lead} />

                <form>
                    <div className='content m-3 mb-4'>
                        <h3 className='text text-dark fw-semibold fs-5 mb-3'>Status und Kontaktwunsch</h3>

                        <p className='text text-secondary fs-6 mb-3'>Der Kunde / Die Kundin wünscht Leistungen in folgenden Bereichen<span className='text text-danger'>*</span></p>
                        <div className='mb-4'>
                            <div className="form-check mb-3">
                                <input className="form-check-input" type="checkbox" checked={wantedServices.findIndex(ws => ws == "Aufnahme als Neukunde") > -1} onChange={(e) => updateWantedServices(e, "Aufnahme als Neukunde")} />
                                <label className="form-check-label text-secondary p-1 ms-3">
                                    Aufnahme als Neukunde
                                </label>
                            </div>
                            <div className="form-check mb-3">
                                <input className="form-check-input" type="checkbox" checked={wantedServices.findIndex(ws => ws == "Informationsmaterial") > -1} onChange={(e) => updateWantedServices(e, "Informationsmaterial")} />
                                <label className="form-check-label text-secondary p-1 ms-3">
                                    Informationsmaterial
                                </label>
                            </div>
                            <div className="form-check mb-3">
                                <input className="form-check-input" type="checkbox" checked={wantedServices.findIndex(ws => ws == "Kundenbesuch") > -1} onChange={(e) => updateWantedServices(e, "Kundenbesuch")} />
                                <label className="form-check-label text-secondary p-1 ms-3">
                                    Kundenbesuch
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className='content m-3 mb-4'>
                        <h3 className='text text-dark fw-semibold fs-5 mb-3'>Informationsmaterial</h3>
                        <p className='text text-secondary fs-6 mb-3'>Der Kunde möchte folgendes Informationsmaterial erhalten<span className='text text-danger'>*</span></p>
                        <div className='mb-4'>
                            <div className="form-check mb-3">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={wantedInformationMaterial.findIndex(ws => ws == "Schulungsunterlagen") > -1}
                                    onChange={(e) => updateWantedInformationMaterial(e, "Schulungsunterlagen")} />
                                <label className="form-check-label text-secondary p-1 ms-3">
                                    Schulungsunterlagen
                                </label>
                            </div>
                            <div className="form-check mb-3">
                                <input className="form-check-input" type="checkbox" checked={wantedInformationMaterial.findIndex(ws => ws == "Newsletter") > -1} onChange={(e) => updateWantedInformationMaterial(e, "Newsletter")} />
                                <label className="form-check-label text-secondary p-1 ms-3">
                                    Newsletter
                                </label>
                            </div>
                            <div className="form-check mb-2 p-0">
                                <input
                                    className="form-control"
                                    type="text" placeholder='Sonstiges, bitte erläutern...'
                                    value={moreWantedInformationMaterial}
                                    onChange={(e) => setMoreWantedInformationMaterial(e.target.value)}
                                    maxLength="220"
                                />
                            </div>
                        </div>
                    </div>

                    <div className='content m-3 mb-4'>
                        <h3 className='text text-dark fw-semibold fs-5 mb-3'>Bereiche</h3>
                        <p className='text text-secondary fs-6 mb-3'>Der Kunde interessiert sich für folgende Produktbereiche:<span className='text text-danger'>*</span></p>
                        <div className='mb-4'>
                            {productAreas.map(area => (
                                <div className="form-check mb-3" key={area}>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={interests.includes(area)}
                                        onChange={(e) => updateInterests(e, area)}
                                    />
                                    <label className="form-check-label text-secondary p-1 ms-3">
                                        {area}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className='content m-3 mb-4'>
                        <h3 className='text text-dark fw-semibold fs-5 mb-3'>Weitere Informationen</h3>
                        <p className='text text-secondary fs-6 mb-3'>Weitere Bedürfnisse des Kunden oder sonstige Informationen zur Anfrage</p>
                        <div className='mb-4'>
                            <div className="form-check mb-2 p-0">
                                <textarea
                                    className="form-control"
                                    placeholder="Bitte eingeben..."
                                    style={{ height: "100px" }}
                                    value={moreInformation}
                                    onChange={(e) => setMoreInformation(e.target.value)}
                                    maxLength="500"
                                />
                            </div>
                        </div>
                    </div>
                </form>

                <div className='row p-3 mb-5'>
                    <button className='lead-button col-12' onClick={onSubmit} disabled={!validation}>Lead absenden</button>
                </div>
            </div>
        </>
    )
}

export default InformationMaterial